module.exports = __webpack_public_path__ + "0461f06ec4e563d81368e010e96d2b81.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/sm-660.webp.png
// module id = 541
// module chunks = 0